import React from "react";
import { Link } from "react-router-dom";
import styles from "./ProductCard.module.css";

export default function ProductCard({ product, isFirst }) {
  let imageRepository = "https://s3.us-east-1.amazonaws.com/esencianomada.com.ar";  
  let imageUrl = `${imageRepository}/${product.images['medium']}`;
  // Dimensiones fijas para evitar CLS
  const imgWidth = 192; // px (12rem, igual que w-48)
  const imgHeight = 192; // px (12rem)
  return (
    <Link to={`/${product.sku}`} className={styles.link}>
      <div className="flex flex-col h-full border border-gray-200 rounded-lg shadow-sm hover:shadow-md">
        <div className="relative flex-shrink-0 m-2 flex items-center justify-center" style={{ minHeight: imgHeight }}>
          <img
            src={imageUrl}
            alt={product.name}
            width={imgWidth}
            height={imgHeight}
            className="w-48 h-48 object-contain bg-white mx-auto rounded"
            {...(!isFirst ? { loading: "lazy" } : {})}
          />
        </div>
        <div className="flex flex-col justify-end flex-1 p-4 mt-auto">
          <h2 className="text-lg font-semibold mb-1 truncate text-center">{product.name}</h2>
          <p className="text-gray-500 text-sm mb-2 line-clamp-2">{product.description}</p>
          <div className="flex flex-nowrap gap-2 whitespace-nowrap overflow-hidden">
            {Array.isArray(product.tags) && product.tags.length > 0 && product.tags.map((tag, idx) => (
              <span key={idx} className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}